( function () {
	'use strict';

	/* @ngInject */
	function templateservice ( apiService, logger, Session, indicatorService, saveTemplateMask, loadTemplateMask, $modal, _ ) {
		var mode = 'save';

		function replaceFormula ( modelId, group, newIndicator ) {
			return ( group.formula || '' ).split( modelId ).join( newIndicator.id );
		}

		function alterGroupFormula ( oldId, newId, model ) {
			model.formula = ( model.formula || '' ).split( oldId ).join( newId );
		}

		function setMode ( customMode ) {
			mode = customMode;
		}

		function save ( userId, data, resource ) {
			return apiService[ resource || 'templates' ][ mode ]( {
				'userId'     : userId,
				'templateId' : data.templateId
			}, saveTemplateMask.pack( data, mode ) )
				.$promise;
		}

		function credentialHandler () {
			return Session.getCredentials();
		}

		var newModel  = {
			'templateId' : '20000000-0000-0000-0000-100000000071',
			'template'   : {
				'name' : 'Untitled Template'
			},

			'tags'   : [ ],
			'groups' : [ {
				'groupName'  : 'Untitled Section',
				'indicators' : [ ]
			} ],

			'formula' : '',
			'creator' : {
				'id' : ''
			},

			'hideScoring' : false
		};

		function getNewModel () {
			var newData = angular.copy( newModel );

			newData.creator.id = credentialHandler().userId;

			return newData;
		}

		function load ( types, data ) {
			if ( data && !data.types.length ) {
				data.types = types;
			}

			if ( data ) {
				return loadTemplateMask.unpack( data );
			}

			var newData = getNewModel();

			newData.types = types;
			newData.groups[ 0 ].id = apiService.generateUUID();
			return angular.copy( newData );
		}

		function observationTypes () {
			return apiService.observationTypes
				.query()
				.$promise.then( function ( resource ) {
					logger.info( 'Observation Types successfully loaded' );
					return resource;
				} );
		}

		function getTemplates ( userId ) {
			return apiService.templates
				.query( {
					'userId' : userId
				} )
				.$promise.then( function ( resource ) {
					logger.info( 'Template List successfully loaded.' );
					return resource;
				} );
		}

		function getTemplate ( userId, templateId, type ) {
			return apiService[ type || 'template' ]
				.get( {
					'userId'     : userId,
					'templateId' : templateId
				} )
				.$promise.then( function ( resource ) {
					logger.info( 'Template successfully loaded.' );
					return resource;
				} );
		}

		// --- Start of `template favorites` API --- //
		function getTemplatesWithFavorites ( userId ) {
			return apiService.library.query( {
				'userId' : userId
			} )
			.$promise
			.then( function ( resource ) {
				logger.info( 'Template favorites loaded.' );
				return resource;
			} );
		}

		function getTemplatesPermission ( userId ) {
			return apiService.templatesPermission.get( {
				'userId' : userId
			} ).$promise;
		}

		function addToTemplateLibrary ( userId, templateId ) {
			return apiService.templateLibrary.save( {
				'userId'     : userId,
				'templateId' : templateId
			} )
			.$promise
			.then( function ( resource ) {
				logger.info( 'added to library' );
				return resource;
			} );
		}

		function removeFromTemplateLibrary ( userId, templateId ) {
			return apiService.templateLibrary.remove( {
				'userId'     : userId,
				'templateId' : templateId
			} )
			.$promise
			.then( function ( resource ) {
				logger.info( 'removed from library' );
				return resource;
			} );
		}

		// --- end of `template favorites` API --- //

		function deleteTemplate ( userId, templateId ) {
			return apiService.template
				.remove( {
					'userId'     : userId,
					'templateId' : templateId
				} ).$promise.then( function ( resource ) {
					return resource;
				} );
		}

		function createNewVersion ( error ) {
			if ( error.status === 500 && error.data.message === 'New version required' ) {
				$modal.open( {
					'templateUrl'  : '/templates/templates-new/templates-new-confirm.html',
					'controller'   : 'ModalConfirm',
					'controllerAs' : 'vm',
					'keyboard'     : false
				} );
			} else if ( error.status === 403 && error.data === 'Forbidden' ) {
				$modal.open( {
					'templateUrl'  : '/templates/templates-new/template-new-read-only.html',
					'controller'   : 'ModalConfirm',
					'controllerAs' : 'vm',
					'keyboard'     : false
				} );
			}
		}

		function digitsOnly ( option, key ) {
			// check each character in the value
			option[ key ] = option.tempValue.split( '' ).filter( function ( digit ) {
				// checks if character in valid
				return '0123456789'.indexOf( digit ) > -1;
			} ).join( '' );
			// map validated values back to original container
			option.tempValue = option[ key ];
		}

		function changeId ( modelData ) {
			var option, subOption;

			if ( !modelData.id ) {
				var groupModel = angular.copy( modelData.groupModel );
				var modelId    = angular.copy( modelData.model.id );

				modelData.model.id           = apiService.generateUUID();
				modelData.groupModel.formula = replaceFormula( modelId, groupModel, modelData.model );
				return;
			}

			if ( modelData.level === 'option' ) {
				option    = _.find( modelData.model.answerOptions, { 'id' : modelData.id } );
				option.id = apiService.generateUUID();
			}

			if ( modelData.level === 'subOption' ) {
				option       = _.find( modelData.model.answerOptions, { 'id' : modelData.id } );
				subOption    = _.find( option.subOptions, { 'id' : modelData.subOptionId } );
				subOption.id = apiService.generateUUID();
			}
		}

		return {
			'save'     : save,
			'load'     : load,
			'setMode'  : setMode,
			'changeId' : changeId,

			'digitsOnly'       : digitsOnly,
			'getTemplate'      : getTemplate,
			'getTemplates'     : getTemplates,
			'deleteTemplate'   : deleteTemplate,
			'createNewVersion' : createNewVersion,
			'observationTypes' : observationTypes,

			'getTemplatesWithFavorites' : getTemplatesWithFavorites,
			'getTemplatesPermission'    : getTemplatesPermission,
			'addToTemplateLibrary'      : addToTemplateLibrary,
			'removeFromTemplateLibrary' : removeFromTemplateLibrary,
			'credentialHandler'         : credentialHandler,
			'alterGroupFormula'         : alterGroupFormula
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'templateservice', templateservice );

	templateservice.$inject = [ 'apiService', 'logger', 'Session', 'indicatorService', 'saveTemplateMask', 'loadTemplateMask', '$modal', '_' ];
} )( );
